export default __webpack_public_path__ + "static/media/actions-etherscan.b3922a4c.svg";